import { render, staticRenderFns } from "./CourseListing.vue?vue&type=template&id=572d375a&scoped=true"
import script from "./CourseListing.vue?vue&type=script&lang=js"
export * from "./CourseListing.vue?vue&type=script&lang=js"
import style0 from "./CourseListing.vue?vue&type=style&index=0&id=572d375a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572d375a",
  null
  
)

export default component.exports